import React, {memo} from 'react';
import PropTypes from 'prop-types';

const PreQuestionSubhint = ({question}) => {
  const subhint = question.get('subhint');

  return subhint ? (
    <p className='caption n700 marginTop-tiny'>{subhint}</p>
  ) : null;
}

PreQuestionSubhint.propTypes = {
  question: PropTypes.object.isRequired,
};

export default memo(PreQuestionSubhint);
